declare global {
  namespace JSX {
    interface IntrinsicElements {
      "hautai-liqa": {
        license: string;
        target: string;
        preset: string;
        hidden?: boolean;
        height: string;
        styles: string;
        messages?: string;
        sources: string;
      };
    }
  }
}

export const Liqa = (props: { hidden?: boolean; isMobile?: boolean }) => {
  const style = props.isMobile
    ? ".j1eoapsl i {display: none !important}.z1ypd5fz {text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black; font-family: Circular; letter-spacing: 0.02em;} .hlfcpwi {text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black; font-family: Circular; letter-spacing: 0.02em;}.fp7rke0 { border-radius: 0px !important;text-transform: uppercase;letter-spacing: 0.08125rem;font-size: 12px;}.sp7rke0 { border-radius: 0px !important;background-color: white !important;color: black !important;text-transform: uppercase;letter-spacing: 0.08125rem;}"
    : ".j1eoapsl i {display: none !important}.z1ypd5fz {text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black; font-family: Circular; letter-spacing: 0.02em;} .hlfcpwi {text-shadow: 1px 1px 2px black, 0 0 1em black, 0 0 0.2em black; font-family: Circular; letter-spacing: 0.02em;}.fp7rke0 { border-radius: 0px !important;text-transform: uppercase;letter-spacing: 0.08125rem;font-size: 12px;}.sp7rke0 { border-radius: 0px !important;background-color: white !important;color: black !important;text-transform: uppercase;letter-spacing: 0.08125rem;} form.hlfcpwi.hlfcpwi {gap: 1rem;padding-left: 10em;padding-right: 10rem;padding-bottom: 2.5rem;}";
  return (
    <hautai-liqa
      license="eyJpZCI6InVsdGEifQ=="
      preset="hair"
      target="#liqa-container-new"
      hidden={props.hidden}
      height="100%"
      styles={style}
      sources="camera,upload"
      messages='{
        "source_selection": {
          "title": "Select the mode below",
          "upload_photo": "Gallery"
        },
        "hair_live_video": {
          "hair_not_visible": "Hair back.", 
          "capturing": ""
        }, 
        "preview": {
          "title": "Your photo has been taken!",
          "text": "Would you like to use it?",
          "retake": "Retake",
          "submit": "Yes"
        } 
      }'
    ></hautai-liqa>
  );
};
